import React from 'react';
import {
  ErrorToastBody,
  Error,
  Close,
  ClickableText,
  DesktopMessage,
  MobileMessage,
} from '@gcc/countertops-components/dist/Toast/styles'; // need to port
import { notify } from '@gcc/countertops-components/dist/Toast/index'; // need to port

const closeAndRetry = (textOnClick) => {
  notify();
  textOnClick();
};

const desktopMessage = (textOnClick) => (
  <DesktopMessage>
    <b>Error!</b>
    &nbsp;
    <span> Something went wrong.</span>
    &nbsp;
    <ClickableText onClick={() => closeAndRetry(textOnClick)}> Please try again.</ClickableText>
  </DesktopMessage>
);

const mobileMessage = (textOnClick) => (
  <MobileMessage>
    <b>Error!</b>
    &nbsp;
    <ClickableText onClick={() => closeAndRetry(textOnClick)}> Please try again.</ClickableText>
  </MobileMessage>
);

const Toast = (textOnClick) => (
  <ErrorToastBody>
    <Error />
    { mobileMessage(textOnClick) }
    { desktopMessage(textOnClick) }
    <Close onClick={() => notify()} />
  </ErrorToastBody>
);

const ConfigSaveFailedToast = (textOnClick) => Toast(textOnClick);

export default ConfigSaveFailedToast;
